import { AugmentedCognitoUser } from 'Types';

export enum SIGN_IN_COMPONENT {
  SIGNIN = 'SIGNIN',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  RESET_PASSWORD = 'RESET_PASSWORD',
  VERIFICATION_CODE = 'VERIFICATION_CODE',
}

export interface AuthReducer {
  authReducer: AuthState;
}

export interface AuthState {
  isAuthenticated: boolean;
  tempSignUpPass: string | undefined; // used only on sign up to sign in after verification
  pendingEmailOrPhone: string | undefined;
  isLoading?: boolean; // We need this in local storage because google auth redirects away
  oauthPending?: boolean;
}

export enum authActionTypes {
  CLEAR_DATA = 'CLEAR_DATA',
  SET_IS_AUTHENTICATED = 'SET_IS_AUTHENTICATED',
  SET_TEMP_SIGNUP_PASS = 'SET_TEMP_SIGNUP_PASS',
  SET_PENDING_EMAIL_OR_PHONE = 'SET_PENDING_EMAIL_OR_PHONE',
  IS_LOADING = 'IS_LOADING',
  SET_IS_LOADING = 'SET_IS_LOADING',
  SET_OAUTH_PENDING = 'SET_OAUTH_PENDING',
}

export interface SetTokenPayload {
  token: string | undefined;
}

export interface SetIdTokenPayload {
  idToken: string;
}

export interface LogInPlayload {
  emailOrPhone: string;
  countryAcronym: string;
  password: string;
}

export interface SignUpPayload {
  name: string;
  emailOrPhone: string;
  password: string;
  repeatPassword: string;
  unknown: string;
  countryAcronym: string;
}

export interface ConfirmSignUpPayload {
  phoneNumber: string;
  countryAcronym: string;
  confirmationCode: string;
}

export interface SetUserPayload {
  user: AugmentedCognitoUser | null;
}

export interface SetPendingEmailOrPhonePayload {
  pendingEmailOrPhone: string;
}

export interface SetPendingEmailOrPhoneSuccessfulPayload {
  pendingEmailOrPhoneSuccessful: boolean;
}

export interface SetIsAuthenticated {
  type: typeof authActionTypes.SET_IS_AUTHENTICATED;
  payload: boolean;
}
export interface SetTempSignUpPass {
  type: typeof authActionTypes.SET_TEMP_SIGNUP_PASS;
  payload: string;
}

export interface SetPendingEmailOrPhone {
  type: typeof authActionTypes.SET_PENDING_EMAIL_OR_PHONE;
  payload: string;
}

export interface SetIsLoading {
  type: typeof authActionTypes.SET_IS_LOADING;
  payload: boolean;
}

export interface SetOauthPending {
  type: typeof authActionTypes.SET_OAUTH_PENDING;
  payload: boolean;
}

export interface ClearData {
  type: typeof authActionTypes.CLEAR_DATA;
}

export type AuthActions =
  | SetTempSignUpPass
  | SetIsAuthenticated
  | SetPendingEmailOrPhone
  | SetIsLoading
  | SetOauthPending
  | ClearData;
